import moment from 'moment/moment';
import {useCallback, useEffect, useState} from 'react';

import {DATE_WITH_TIME, DATE_WITH_TIME_DOTS_SECONDS_24} from 'shared/constants/date-format';
import {useAppSelector} from 'store/config/hooks';
import {selectIsAuthenticated} from 'store/slices/auth-slice';

import {fetchFooterText, fetchLoginIpData} from '../footer-api';

type TLoginInfo = {
    date: string;
    ip: string;
}

export const useFooterText = () => {
    const [footerText, setFooterText] = useState('');
    const [loginInfo, setLoginInfo] = useState<TLoginInfo>({
        date: '',
        ip: '',
    });
    const isAuthorized = useAppSelector(selectIsAuthenticated);

    const setFooterTextFromServer = useCallback(async () => {
        try {
            const {data, status} = await fetchFooterText();
            const isValidText = status === 200 && typeof data === 'string';

            if (isValidText) {
                setFooterText(data);
            }
        } catch (error) {
            console.error(error);
        }
    }, [setFooterText]);

    const setFooterLoginAndIpData = useCallback(async () => {
        if (!isAuthorized) return;
        try {
            const {data, status} = await fetchLoginIpData();
            const formattedDate = moment(data.date, DATE_WITH_TIME).format(DATE_WITH_TIME_DOTS_SECONDS_24);
            const isValid = status === 200
                && moment(formattedDate, DATE_WITH_TIME_DOTS_SECONDS_24).isValid()
                && data.ip;

            if (isValid) {
                setLoginInfo({ip: data.ip, date: formattedDate});
            }
        } catch (error) {
            console.error(error);
        }
    }, [setLoginInfo, isAuthorized]);

    useEffect(() => {
        setFooterTextFromServer();
        setFooterLoginAndIpData();
    }, []);

    return {footerText, loginInfo};
};
